import routes from './routes';
import run from '../../bootstrap';
import defaultThemes from '../../theme/default';
import themes from './theme';
import myPageConfig from './config';
import locales from '../../../../locales';
import { publicationConfig } from '../../vNext/config/publications/sno';

run({
    routes: routes(),
    themes: {
        default: defaultThemes,
        sno: themes,
    },
    initialState: {
        intl: locales.loadLocaleFromConfig(),
    },
    myPageConfig,
    publicationConfig,
});
